import { render, staticRenderFns } from "./SuccessStoryQuote.vue?vue&type=template&id=b8c02986"
import script from "./SuccessStoryQuote.vue?vue&type=script&lang=js"
export * from "./SuccessStoryQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports